import { getChatConfigValue } from '@/lib/chat-config';

interface CandidateLoadingScreenProps {
  localeId: number;
  message?: string;
  dataTest?: string;
}

/**
 * The one waiting screen from link open to chat: the static copy in
 * `index.html`, route loading, a quick-start submit and the chat's own loaders
 * all render this, in the same fixed box and colour, so the only visible
 * change is the chat arriving. Keep `index.html`'s copy in step.
 */
export function CandidateLoadingScreen({
  localeId,
  message,
  dataTest = 'candidate-loading',
}: CandidateLoadingScreenProps) {
  return (
    <div
      data-test={dataTest}
      className="bg-background fixed inset-0 z-50 flex flex-col items-center justify-center px-4"
    >
      <div className="flex flex-col items-center gap-6">
        <div className="relative">
          <div className="bg-primary/10 h-16 w-16 rounded-2xl" />
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="border-primary h-8 w-8 animate-spin rounded-full border-2 border-t-transparent" />
          </div>
        </div>
        <div className="flex flex-col items-center gap-2 text-center">
          <h2 className="text-foreground min-h-7 text-lg font-semibold">
            {getChatConfigValue('client_ui', 'loading_title', localeId)}
          </h2>
          <p
            data-test="candidate-loading-message"
            className="text-muted-foreground min-h-5 max-w-xs text-sm"
          >
            {message}
          </p>
        </div>
        <div className="flex items-center gap-1.5">
          <span className="bg-primary h-2 w-2 animate-bounce rounded-full [animation-delay:-0.3s]" />
          <span className="bg-primary h-2 w-2 animate-bounce rounded-full [animation-delay:-0.15s]" />
          <span className="bg-primary h-2 w-2 animate-bounce rounded-full" />
        </div>
      </div>
    </div>
  );
}
